import {DeserializedRecord, Deserializer, JSONAPIRecord} from "../../Helpers";
import {deserializeItem} from "../../index";

interface TenantItem extends DeserializedRecord {
  id: string;
  name: string;
  externalName: string;
  description: string;
  cfPatientRestriction?: "DE-gesetzlich" | "DE-privat";
}

interface TenantItemPriceWithItem extends DeserializedRecord {
  id: string;
  itemPrice: TenantItemPrice;
  item: TenantItem;
}

interface TenantItemPrice extends DeserializedRecord {
  id: string;
  name: string;
  externalName: string;
  description: string;
  price: number;
  currencyCode: 'EUR';
}

interface TenantItemPriceWithItemData extends JSONAPIRecord {
  attributes: {
    item: {
      data: JSONAPIRecord
    },
    item_price: {
      data: JSONAPIRecord
    }
  },
}

const deserializeTenantItemPriceWithItem: Deserializer<TenantItemPriceWithItem, TenantItemPriceWithItemData> = (data) => ({
  ...deserializeItem(data),
  item: deserializeItem<TenantItem>(data.attributes.item.data),
  itemPrice: deserializeItem<TenantItemPrice>(data.attributes.item_price.data)
});

export {
  TenantItem,
  TenantItemPrice,
  TenantItemPriceWithItem,
  TenantItemPriceWithItemData,
  deserializeTenantItemPriceWithItem
};
